

import { Button, Col, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface RecoverPasswordFormProps {
    onFinish: (email: string, password: string) => void,
    email: string
    isLoading: boolean
}

const RecoverPasswordForm = (props: RecoverPasswordFormProps): JSX.Element => {
    const { t } = useTranslation();

    const [form] = useForm();

    const onFinishForm = (): void => {
        form.validateFields().then((values) => {
            props.onFinish(values.email, values.password);
        });
    }



    return (
        <div className="contact-form-component">
            <Form form={form} layout='vertical' onFinish={onFinishForm} >
                <Row gutter={16}>
                    <Col xs={24} >
                        <Row gutter={16}>
                            <Col xs={24}>
                                <Form.Item
                                    label={t("components.contact-form.email")}
                                    name="email"
                                    initialValue={props.email}
                                >
                                    <Input
                                        disabled={true}
                                        className="app-input" />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item
                                    label={t("components.login-form.password")}
                                    name="password"
                                    rules={[{ required: true, message: t("forms.validations.required-field")! }]}
                                >
                                    <Input.Password className="app-input" />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item
                                    label={t("components.edit-profile.repeat-password")}
                                    name="passwordRepeat"
                                    dependencies={['password']}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const password = getFieldValue("password");
                                                if ((!password && !value) || password === value) {
                                                    // Si ambos están vacíos o coinciden, es válido
                                                    return Promise.resolve();
                                                }
                                                // Caso en el que el password no coincide
                                                return Promise.reject(t("forms.validations.not-match"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password className="app-input" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <div className="actions">
                    <Button className="app-button send-form-data" disabled={props.isLoading} loading={props.isLoading} htmlType='submit'>
                        {t('button.change-password')}
                    </Button>
                </div>
            </Form>

        </div>
    )
}

export default RecoverPasswordForm;